import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '韩漫在线观看需要付费吗？',
    answer: '完全不需要！韩漫在线观看致力于提供免费的漫画下拉式阅读服务。您可以通过我们的漫画网址直接访问所有韩漫资源，无需注册、无需付费，即可享受流畅的阅读体验。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是一种创新的漫画阅读方式，您只需要在页面上向下滚动即可连续阅读漫画内容，无需点击翻页按钮。这种阅读方式更加流畅自然，让您可以沉浸在漫画故事中，享受无缝的阅读体验。',
  },
  {
    question: '网站上的韩漫资源多久更新一次？',
    answer: '我们的漫画网站每天都会更新最新的韩漫章节和资源。热门连载作品通常会在原版发布后的24小时内完成同步更新，确保您不会错过任何精彩内容。您可以在"最新更新"板块查看当天更新的所有作品。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '韩漫在线观看采用了响应式设计，完美适配电脑、平板和手机等各种设备。无论您使用什么设备，都可以通过我们的漫画网址获得最佳的阅读体验。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过多种方式找到心仪的漫画：使用顶部的分类导航按类型浏览；在首页"热门推荐"中查看人气作品；在"最新更新"中关注最近更新的漫画；还可以使用搜索功能直接查找特定作品。',
  },
  {
    question: '漫画加载慢怎么办？',
    answer: '韩漫漫画网站采用了优化的CDN加速技术，确保漫画图片的加载速度。如果遇到加载缓慢的情况，建议检查您的网络连接，或尝试刷新页面。我们持续优化服务器性能，为您提供稳定可靠的服务。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="faq-title">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2
            id="faq-title"
            className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3"
          >
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于韩漫在线观看的常见疑问，这里都有解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <h3 className="font-heading text-sm md:text-base text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                    style={{ width: '20px', height: '20px' }}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}